export default "__VITE_ASSET__d1967167__"